import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import { useUpdateGroup } from '@/services/groups/groups.service';
import styles from './AddStoresModal.module.css';
import { AddStoresModalProps } from './AddStoresModal.types';

const MoveStoresModal: FC<AddStoresModalProps> = ({
  isOpen,
  onClose,
  selectedStores,
  currentGroupId,
  onSuccess,
  onError,
  emptyStoreGroups,
  groupName,
}) => {
  const { t } = useTranslation();
  const { mutate, isLoading } = useUpdateGroup(currentGroupId);

  const hasEmptyGroups = emptyStoreGroups.length > 0;

  const handleConfirm = () => {
    mutate(
      {
        name: groupName,
        stores: selectedStores.map((store) => store.storeNo),
      },
      {
        onSuccess,
        onError,
      },
    );
  };

  return (
    <Modal
      className={styles.moveStores}
      isOpen={isOpen}
      onClose={onClose}
      headerContent={hasEmptyGroups ? t('moveStoresModal.titleMove') : t('moveStoresModal.title')}
      data-testid="Modal"
      showTitleDivider
      bodyContent={
        <div className={styles.moveStoresBody}>
          <div className={styles.newGroupSelection} data-testid="addStoresModalBody">
            {hasEmptyGroups && (
              <span className={styles.storeFont}>
                The {emptyStoreGroups.join(', ')} group(s) will be deleted because there are no stores remaining.
              </span>
            )}
          </div>
        </div>
      }
      footerContent={
        <div className={styles.footer}>
          <div className={styles.buttons}>
            <Button
              data-testid="addStoresModalCancel"
              variant={ButtonVariants.Secondary}
              onClick={onClose}
              type="button"
            >
              {t('common.cancel')}
            </Button>
            <Button data-testid="addStoresModalConfirm" onClick={handleConfirm} type="button" isLoading={isLoading}>
              {hasEmptyGroups ? t('moveStoresModal.confirmButton') : t('common.confirm')}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default MoveStoresModal;
